import React, { useEffect, useState } from 'react';
import ToolManagmentCard from '../../../../common/element/Card/ToolManagmnetCard';

const QuizMasterView = () => {
  const [mcqAnswer] = useState('D');
  const [multiSelect] = useState(['D']);
  const [rating] = useState(2);
  const [subjective] = useState('Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.');

  return (
    <div className="min-h-screen">
      <div className="max-full">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-xl font-semibold text-gray-900">Feedback Quiz</h1>
          <button className="px-4 py-2 bg-orange-50 text-orange-600 rounded-md text-sm font-medium border border-orange-100">
            Back
          </button>
        </div>

        {/* MCQ Question */}
        <ToolManagmentCard>
          <div className="bg-orange-50 w-[80px] h-[33px] opacity-100 rounded-lg gap-2 px-5 py-[6px]  text-md mb-3">
            MCQ
          </div>
          <h2 className="text-base font-semibold text-gray-900 mb-4 text-start">
            Which is the following is a sales Technique?
          </h2>
          <div className="space-y-2.5">
            {[
              { id: 'A', text: 'Cold Calling' },
              { id: 'B', text: 'Email Marketing' },
              { id: 'C', text: 'Networking' },
              { id: 'D', text: 'None of these' }
            ].map(option => (
              <label key={option.id} className="flex items-center">
                <div className="relative flex items-center">
                  <input
                    type="radio"
                    name="mcq"
                    checked={mcqAnswer === option.id}
                    readOnly
                    className="w-4 h-4 border-2 rounded-full border-orange-400 checked:bg-orange-500 checked:border-orange-500 focus:ring-0 focus:outline-none appearance-none"
                  />
                  <span className="ml-2.5 text-sm text-gray-700">
                    {option.id}. {option.text}
                  </span>
                </div>

              </label>
            ))}
          </div>
        </ToolManagmentCard>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-5">
          {/* Multi-Select Question */}
          <ToolManagmentCard>
           <div className="bg-orange-50 w-[116px] h-[33px] opacity-100 rounded-lg px-5 py-[6px]  text-md mb-3">
  Multi-Select
</div>


            <h2 className="text-base font-semibold text-gray-900 mb-4 text-start">
              Which Tool do you use for CRM?
            </h2>
            <div className="space-y-2.5">
              {[
                { id: 'A', text: 'Salesforce' },
                { id: 'B', text: 'Hubspot' },
                { id: 'C', text: 'Zoho CRM' },
                { id: 'D', text: 'All of these above' }
              ].map(option => (
                <label key={option.id} className="flex items-center">
                  <div className="relative flex items-center">
                    <input
                      type="checkbox"
                      checked={multiSelect.includes(option.id)}
                      readOnly
                      className="w-4 h-4 text-orange-500 border-gray-300 rounded focus:ring-0"
                    />
                    <span className="ml-2.5 text-sm text-gray-700">
                      {option.id}. {option.text}
                    </span>
                  </div>
                </label>
              ))}
            </div>
          </ToolManagmentCard>

          {/* Subjective Question */}
          <ToolManagmentCard >
            <div className="bg-orange-50 w-[116px] h-[33px] opacity-100 rounded-lg px-5 py-[6px]  text-md mb-3">
              Subjective
            </div>
            <h2 className="text-base font-semibold text-gray-900 mb-4 text-start">
              Explain your approach to closing a deal.
            </h2>
            <textarea
              value={subjective}
              readOnly
              className="w-full h-32 p-3 border border-gray-300 rounded-md resize-none text-sm text-gray-700 bg-white focus:outline-none"
              placeholder="Enter your answer here..."
            />
          </ToolManagmentCard>
        </div>

        {/* Rating Question */}
        <ToolManagmentCard>
          <div className="bg-orange-50 w-[80px] h-[33px] opacity-100 rounded-lg gap-2 px-5 py-[6px]  text-md mb-3">
            Rating
          </div>

          <h2 className="text-base font-semibold text-gray-900 mb-4 text-start">
            Rate your Confidence in handling objections.
          </h2>
          <div className="space-y-2.5">
            {[5, 4, 3, 2, 1].map(stars => (
              <label key={stars} className="flex items-center">
                <div className="relative flex items-center">
                  <input
                    type="radio"
                    name="rating"
                    checked={rating === stars}
                    readOnly
                    className="w-4 h-4 border-2 rounded-full border-orange-400 checked:bg-orange-500 checked:border-orange-500 focus:ring-0 focus:outline-none appearance-none"
                  />
                  <div className="ml-2.5 flex gap-0.5">
                    {[...Array(stars)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-5 h-5 text-yellow-400 fill-current"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                      </svg>
                    ))}
                  </div>
                </div>
              </label>
            ))}
          </div>
        </ToolManagmentCard>
      </div>
    </div>
  );
};

export default QuizMasterView;